import './table.css';
import { useEffect, useState } from 'react';
import cloudSun from '../images/cloud-sun.png';
import cloud from '../images/Clouds.png';
import DeleteIcon from '../images/delete-icon.png';
import Lightning from '../images/Light-bolt.png';
import rain from '../images/rain.png';
import snow from '../images/snowflakes.png';
import sun from '../images/sun.png';
import wind from '../images/wind.png';

export default function Table3() {
  // Define color options with descriptions
  const colorOptions = [
    { color: '#FFD700', icon: sun }, // Bright yellow for sunny
    { color: '#87CEEB', icon: cloudSun }, // Sky blue for partly cloudy
    { color: '#4682B4', icon: rain }, // Steel blue for rain
    { color: '#F0F8FF', icon: snow }, // Alice blue for snow
    { color: '#B8C4CC', icon: wind }, // Cool gray for wind
    { color: '#483D8B', icon: Lightning }, // Dark slate blue for lightning
    { color: '#A9A9A9', icon: cloud }, // Dark gray for cloudy
    { color: '#FFFFFF', icon: DeleteIcon }, // White for delete
  ];

  // Add unique identifier for table2
  const [tableColors, setTableColors] = useState(
    () =>
      JSON.parse(localStorage.getItem('tableColors3')) || // Changed key name
      Array.from({ length: 31 }, () => Array(12).fill(null)),
  );

  // State to track the currently selected color
  const [selectedColor, setSelectedColor] = useState(
    () => localStorage.getItem('selectedColor3') || null, // Changed key name
  );

  useEffect(() => {
    localStorage.setItem('tableColors3', JSON.stringify(tableColors)); // Changed key name
  }, [tableColors]);

  useEffect(() => {
    localStorage.setItem('selectedColor3', selectedColor); // Changed key name
  }, [selectedColor]);

  // Handle color change for a specific cell
  const handleColorChange = (rowIndex, colIndex) => {
    if (!selectedColor) return; // Do nothing if no color is selected
    const newTableColors = [...tableColors];
    newTableColors[rowIndex][colIndex] = selectedColor;
    setTableColors(newTableColors);
  };

  return (
    <div>
      <div className="header-rate-day">
        <h1>Weather Tracker</h1>
        <ol>
          <li>Pick a color from the options below</li>
          <li>Click on a cell to color your day</li>
          <li>See you again tomorrow </li>
        </ol>
      </div>
      <div className="table-container">
        {/* Table */}
        <table>
          <thead>
            <tr>
              <th>Day</th>
              {['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'].map(
                (month, index) => (
                  <th key={index}>{month}</th>
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {tableColors.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex + 1}</td>
                {row.map((color, colIndex) => (
                  <td
                    key={colIndex}
                    onClick={() => handleColorChange(rowIndex, colIndex)}
                    style={{ backgroundColor: color }}
                  ></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Color Picker */}
        <div className="color-picker-container">
          <div className="color-picker">
            <h4>Select the Weather</h4>
            {colorOptions.map(({ color, icon }, index) => (
              <div
                key={index}
                onClick={() => {
                  console.log(`Color selected: ${color}`);
                  setSelectedColor(color);
                }}
              >
                <div
                  className={`color-box ${
                    selectedColor === color ? 'selected' : ''
                  }`}
                  style={{ backgroundColor: color }}
                ></div>
                <img src={icon} alt="weather-icon" className="weather-icon" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
